import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Buttons, Div } from './styles';

interface SuccessMessageProps {
  handleNext: () => void;
  meetingIdCreatedAt: string;
}

export const SuccessMessage = ({
  handleNext,
  meetingIdCreatedAt,
}: SuccessMessageProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Div>
        <CheckCircleOutlineRounded
          sx={{ width: '66px', height: '66px', color: '#4CAF50' }}
        />
        <span>Reunião criada com sucesso!</span>
      </Div>
      <Buttons>
        <Button
          variant="contained"
          onClick={() => navigate(`detalhes-reuniao/${meetingIdCreatedAt}`)}
        >
          Acessar a reunião
        </Button>
        <Button variant="outlined" href="/home/reunioes">
          Voltar para reuniões
        </Button>
      </Buttons>
    </Box>
  );
};
